import React from 'react';
import UsersTable from './UsersTable';

const Navigation = () => {    
    return (
        <div style={{ padding: 10, color: "white", backgroundColor: "#6B747F" }}>
            <UsersTable />                    
        </div>
    );
};

export default Navigation;